<template>
  <a-row>
    <a-col class="map_container">
      <div id="map"></div>
    </a-col>
    <a-col class="detail_data_container">
      <div class="points_panel">
        <div>
          <p>第 {{getCurrentPointIndex}}/{{currentPointInfo.totalPointsNum}} 筆</p>
          <p>
            <span><img src="../../assets/icons/map_clock_icon.svg" alt=""></span>
            {{currentTime}}
          </p>
          <p>
            <span><img src="../../assets/icons/detail_car_status.svg" alt="" class="detail_car_ststus"></span>
            {{ (isTbox) ? currentGpsSpeed : currentSpeed}} km/h
          </p>
          <p>
            <span>
              <img src="../../assets/icons/map_location_icon.svg" alt="" class="detail_location">
            </span>
            {{currentLon}}, {{currentLat}}
          </p>
        </div>
        <div>
          <button @click="switchToPrePoint" :class="dataAlreadyFirstStyle" :disabled="isButtonDisabled">
            <img v-show="dataAlreadyFirstStyle" src="../../assets/icons/pre_point_end.svg" alt="">
            <img v-show="!dataAlreadyFirstStyle" src="../../assets/icons/pre_point.svg" alt="">
            上一點
          </button>
          <button @click="turnToPointsListPage">查看點位列表</button>
          <button @click="switchToNextPoint" :class="dataAlreadyLastStyle" :disabled="isButtonDisabled">
            <img v-show="dataAlreadyLastStyle" src="../../assets/icons/next_point_end.svg" alt="">
            <img v-show="!dataAlreadyLastStyle" src="../../assets/icons/next_point.svg" alt="">
            下一點
          </button>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
  import Map from "ol/Map";
  import View from "ol/View";
  import { Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
  import { XYZ } from 'ol/source';
  import VectorSource from 'ol/source/Vector';
  import { fromLonLat} from 'ol/proj';
  import Feature from 'ol/Feature';
  import { Style, Stroke, Icon } from 'ol/style';
  import LineString from 'ol/geom/LineString';
  import { defaults } from "ol/control";
  import { GeoJSON } from 'ol/format';
  import { Point } from 'ol/geom';
  import {defaults as defaultInteractions} from 'ol/interaction';
  import '../../../node_modules/ol/ol.css';
  import { mapActions, mapState } from 'vuex';
  import drivingIcon from "../../assets/icons/car_status_driving.svg";
  import flameoutIcon from "../../assets/icons/car_status_flameout.svg";
  import idleIcon from "../../assets/icons/car_status_Idle.svg";
  import lostIcon from "../../assets/icons/car_status_lost.svg";

  // 圖磚URL
  const url = 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}';
  const dafaultPosition = [121.4591572, 25.0601437];
  // // 限制地圖可拖拉的範圍界限(因為地圖縮到很小時，超出圖磚範圍的地方會有空白，故限制可拖拉的大概範圍為整個台灣本島)
  // const extentBound = boundingExtent([[118.230796, 21.707473], [123.229752, 25.60011]]);
  // 設定圖磚的圖層
  const tileLayer = new TileLayer({
    source: new XYZ({
      url,
    }),
  });

  const styles = {
    // 路徑線條樣式為openlayer原先的樣式，可自定義相關顏色
    route: new Style({
      stroke: new Stroke({
        width: 6,
        color: '#95acf7',
      }),
    }),
    routeBorder: new Style({
      stroke: new Stroke({
        width: 2,
        color: '#B3DFEE',
      }),
    }),
  };

  // 行駛中marker樣式
  const drivingMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: drivingIcon,
    }),
  });

  // 熄火marker樣式
  const flameoutMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: flameoutIcon,
    }),
  });

  // 失聯marker樣式
  const lostMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: lostIcon,
    }),
  });

  // 怠速中marker樣式
  const idleMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: idleIcon,
    }),
  });




  export default {
    name: 'IndividualScheduleDetailData',
    data() {
      return {
        // 因為地圖下方有資訊區塊，為了使marker在畫面中間，故將中心點的緯度偏移0.0005
        mapCenter: fromLonLat([dafaultPosition[0], dafaultPosition[1] - 0.0005]),
        zoom: 16,
        map: null,
        // api回傳的所有點位資料
        scheduleDetailData: [],
        // 存放所有的點，以繪製路徑
        schedulePoints: [],
        currentPointInfo: {
          totalPointsNum: 0,
          time: '',
          speed: '',
          coordinate: [],
          carStatus: '',
          azimuth: 0,
          gpsSpeed: 0,
        },
        currentPointIndex: 0,
        msgObj: {
            visible: false,
            title: '發送錯誤',
            okText: '確認',
            cancelText: '',
            detailText: '',
            msgClass: 'msg_confirm_modal',
        },
        isTbox:false
      }
    },
    mounted() {

      const {
        startTime, endTime, journeyCode
      } = this.$route.query;

      const params = {
        ...this.$route.query,
        journeyCode: Number(journeyCode),
        deviceUid: this.deviceUid
      }
      if(startTime && endTime){
        Object.assign(params, {
          startTime: parseInt(startTime,10),
          endTime:parseInt(endTime,10)
        })
      }
      if(journeyCode){
        Object.assign(params, {
          journeyCode: parseInt(journeyCode,10),
        })
      }

      this.getScheduleDetailData(params);
      // this.getScheduleDetailData({ ...this.$route.query, deviceUid: this.deviceUid });
    },
    methods: {
      ...mapActions('scheduleDetailData', ['scheduleDetailDataAction']),
      initiateMap() {
        this.map = new Map({
          target: "map",
          layers: [tileLayer],
          view: this.view,
          controls: defaults({
            zoom: false, // 關閉左上角的縮放按鈕控件
          }),
          interactions: defaultInteractions({
            pinchRotate: false // 移動端禁止地圖旋轉
          }),
        });
        // 將所有點的座標以陣列方式儲存(為了畫路徑)
        this.schedulePoints = this.scheduleDetailData.map(pointData => {
          const { longitude, latitude } = pointData.gps;
          return [longitude, latitude]
        });
        // 取得該行程總共有幾個點
        this.currentPointInfo.totalPointsNum = this.scheduleDetailData.length;
        // 寫入預設第一個點的時間、速度、車輛狀態、方位角、座標
        this.currentPointInfo.time = this.scheduleDetailData[this.currentPointIndex].time;
        this.currentPointInfo.speed = this.scheduleDetailData[this.currentPointIndex].can?.canSpeed;
        this.currentPointInfo.carStatus = this.scheduleDetailData[this.currentPointIndex].carStatus;
        this.currentPointInfo.azimuth = this.scheduleDetailData[this.currentPointIndex].gps?.azimuth;
        this.currentPointInfo.coordinate = [this.scheduleDetailData[this.currentPointIndex].gps.longitude, this.scheduleDetailData[this.currentPointIndex].gps.latitude];
        this.currentPointInfo.gpsSpeed = this.scheduleDetailData[this.currentPointIndex].gps.speed;

        // 將地圖中心點變為預設的第一個點
        this.map.getView().setCenter(fromLonLat(this.currentPointInfo.coordinate));
        this.map.addLayer(this.routeLayer);
        this.map.addLayer(this.pointLayer);

        // 監聽地圖縮放事件，進行縮放時將目前的zoom存到sessionStorage
        this.map.getView().on('change:resolution', () => {
            sessionStorage.setItem('currentScheduleDetailDataZoom', this.map.getView().getZoom());
        })
      },
      switchToNextPoint() {
        if (this.currentPointIndex === (this.currentPointInfo.totalPointsNum - 1)) return;
        this.currentPointIndex++;
      },
      switchToPrePoint() {
        if (this.currentPointIndex === 0) return;
        this.currentPointIndex--;
      },
      turnToPointsListPage() {

        const deviceUid = this.$route.query.data || '';
        this.$router.push(`/individual/schedule/route?data=${encodeURIComponent(deviceUid)}`);
      },
      async getScheduleDetailData(params) {
          try {
              // delete params column
              delete params.data;
              const result = await this.scheduleDetailDataAction(params);
              console.log('scheduleDetailData : ', result);
              this.scheduleDetailData = result.list;
              this.isTbox = (result.productName === 'STMB-4000') ? true : false;
              this.initiateMap();
          } catch (errorStatus) {
              console.log(errorStatus);
              this.combineErrMsg(errorStatus);
              this.$emit('responseStatus', this.msgObj);
          }
      },
      combineErrMsg(status) {
          switch (status) {
              // 3:設備不存在、4:設備停用
              case 3:
              case 4:
                  this.msgObj = {
                      ...this.msgObj,
                      visible: true,
                      title: '裝置不存在',
                      okText: '撥打電話',
                      cancelText: '否',
                      detailText: '查無此裝置資訊，請聯繫客服人員',
                      msgClass: 'msg_error_modal',
                  };
                  break;
              case 5:
                  this.msgObj = {
                      ...this.msgObj,
                      detailText: '設備未開通',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 6:
                  this.msgObj = {
                      ...this.msgObj,
                      detailText: '設備過期',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 7:
                  this.msgObj = {
                      ...this.msgObj,
                      detailText: '設備已損壞',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              case 8:
                  this.msgObj = {
                      ...this.msgObj,
                      detailText: '查詢錯誤',
                      visible: true,
                      msgClass: 'msg_confirm_modal'
                  };
                  break;
              default:
                  break;
          }
      },
    },
    computed: {
      ...mapState('identidyOpenStatus', ['deviceUid']),
      // 設定地圖的視圖
      view() {
        return new View({
          center: this.mapCenter,
          zoom: sessionStorage.getItem('currentScheduleDetailDataZoom') || this.zoom,
          minZoom: 7,
          maxZoom: 18,
          // extent: transformExtent(extentBound, 'EPSG:4326', 'EPSG:3857'),
        })
      },
      routeSource() {
        // 以路徑(LineString)的方式新增要素(feature)
        const routeFeature = new Feature({
            type: 'route',
            geometry: new LineString(this.schedulePoints)
            .transform('EPSG:4326', 'EPSG:3857'),
          });

        // 將要素放到數據來源(source)裡面
        return new VectorSource({
          features: [routeFeature],
        })
      },
      pointSource() {
        // 剛載入時，預設以第一個點建立Feature
        const pointFeature = new Feature({
            geometry: new Point(fromLonLat(this.currentPointInfo.coordinate)),
          });

        return new VectorSource({
          features: [pointFeature],
          format: new GeoJSON(),
        })
      },
      routeLayer() {
        const layer = new VectorLayer({
          source: this.routeSource,
          style: feature => [styles[feature.get('type')], styles.routeBorder],
        });

        return layer;
      },
      pointLayer() {
        const layer = new VectorLayer({
          source: this.pointSource,
          style: () => {
            let style = null;
            switch (this.currentPointInfo.carStatus) {
              case 'driving':
                style = drivingMarkerStyle;
                break;
              case 'idling':
                style = idleMarkerStyle;
                break;
              case 'parking':
                style = flameoutMarkerStyle;
                break;
              case 'lost':
                style = lostMarkerStyle;
                break;
              default:
                break;
            }
            style.getImage().setRotation((this.currentPointInfo.azimuth - 90) * Math.PI * 2 / 360);
            return style;
          }
        });

        return layer;
      },
      getCurrentPointIndex() {
        if (!this.currentPointInfo.totalPointsNum) return '00';
        return this.currentPointIndex + 1 >= 10 ? this.currentPointIndex + 1 : `0${this.currentPointIndex + 1}`
      },
      dataAlreadyFirstStyle() {
        if (!this.currentPointInfo.totalPointsNum) return 'disabled_btn_first';
        return this.currentPointIndex === 0  ? 'disabled_btn_first' : '';
      },
      dataAlreadyLastStyle() {
        if (!this.currentPointInfo.totalPointsNum) return 'disabled_btn_last';
        return this.currentPointIndex === this.currentPointInfo.totalPointsNum - 1 ? 'disabled_btn_last' : '';
      },
      isButtonDisabled() {
        return !this.currentPointInfo.totalPointsNum;
      },
      currentTime() {
        return this.currentPointInfo.time ? this.$moment(this.currentPointInfo.time).format('HH:mm:ss') : '--';
      },
      currentSpeed() {
        return (this.currentPointInfo.speed>=0)?this.currentPointInfo.speed : '--';
      },
      currentLon() {
        return (this.currentPointInfo.coordinate[0])?this.currentPointInfo.coordinate[0] : '--';
      },
      currentLat() {
        return (this.currentPointInfo.coordinate[1])?this.currentPointInfo.coordinate[1] : '--';
      },
      currentGpsSpeed(){
        return (this.currentPointInfo.gpsSpeed !== undefined)? this.currentPointInfo.gpsSpeed: '--';
      },
    },
    watch: {
      // 等到openlayers的map掛載完畢後，才變動currentPointIndex的值
      map() {
        this.currentPointIndex = sessionStorage.getItem('scheduleDetailPageFromPathName') === 'individualRoute' ?
        parseInt(sessionStorage.getItem('selectPointIndex'), 10) : 0;
      },
      // 等上面map掛載完，才觸發currentPointIndex的watch，避免執行裡面程式碼噴錯
      currentPointIndex() {
        this.map.removeLayer(this.pointLayer);
        // 寫入預設目前點的時間、速度、車輛狀態、方位角、座標
        this.currentPointInfo.time = this.scheduleDetailData[this.currentPointIndex].time;
        this.currentPointInfo.speed = this.scheduleDetailData[this.currentPointIndex].can?.canSpeed;
        this.currentPointInfo.carStatus = this.scheduleDetailData[this.currentPointIndex].carStatus;
        this.currentPointInfo.azimuth = this.scheduleDetailData[this.currentPointIndex].gps?.azimuth;
        this.currentPointInfo.coordinate = [this.scheduleDetailData[this.currentPointIndex].gps.longitude, this.scheduleDetailData[this.currentPointIndex].gps.latitude];
        this.currentPointInfo.gpsSpeed = this.scheduleDetailData[this.currentPointIndex].gps.speed;

        // 將地圖中心點變為目前的點
        this.map.getView().setCenter(fromLonLat(this.currentPointInfo.coordinate));

        this.map.addLayer(this.pointLayer);
      }
    },
  };
</script>

<style scoped lang="scss">
  .map_container {
    height: calc((100vh - 89px) * 0.7);
    top: 53px;
    #map {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background-color: rgb(163, 203, 255);
    }
  }
  .detail_data_container {
    top: 53px;
    height: calc((100vh - 89px) * 0.3);
    // padding: 10px 12px;
    box-shadow: 0px 0px 0.8px rgba(0, 0, 0, 0.06),
    0px 0px 2px rgba(0, 0, 0, 0.04),
    0px 0px 5px rgba(0, 0, 0, 0.04),
    0px 0px 17px rgba(0, 0, 0, 0.03);
    .points_panel {
      height: 100%;
      display: flex;
      justify-content: space-between;
      div {
        &:first-child {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 8px 12px;
          p {
            margin-bottom: 0;
            color: #343741;
            display: flex;
            &:first-child {
              font-weight: 500;
            }
            span {
              width: 23px;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              img {
                margin-right: 10px;
              }
            }
            .detail_car_ststus {
              width: 15px;
            }
            .detail_location {
              width: 12px;
            }
          }
        }
        &:last-child {
          flex-basis: 140px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 8px 12px;
          button {
            background: #FFFFFF;
            border: 1px solid rgba(19, 34, 149, 0.1);
            box-sizing: border-box;
            border-radius: 8px;
            padding: 6px 11px;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.85);
            img {
              margin-right: 9px;
            }
          }
          button.disabled_btn_first, button.disabled_btn_last {
            background: #E5E5E5;
            color: rgba(0, 0, 0, 0.25);
          }
        }
      }
    }
  }

  @media (max-width: 320px) {
    .detail_data_container {
      .points_panel {
        div {
          &:first-child {
            p {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
</style>
